import React from "react";

export const Required = () => {
    return (
        <span style={{ color: 'red' }}>
            *
        </span>
    )
}